import axios from "axios";

import { initCommonSettings } from "@krea/customer-features/settings";

const getKreaBaseUrl = () => {
  let url = "http://localhost:8000";

  if (import.meta.env.REACT_APP_APPLICATION_ENV === "production") {
    url = "https://customer-api.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "staging") {
    url = "https://staging.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "test") {
    url = "https://test.krea.se";
  } else if (import.meta.env.REACT_APP_APPLICATION_ENV === "local-docker") {
    url = "http://localhost:8000";
  }

  return url;
};

const settings = initCommonSettings({
  environment: import.meta.env.REACT_APP_APPLICATION_ENV || "local",
  backendBaseUrl: getKreaBaseUrl(),
  unauthorizedPaths: [
    "/login",
    "/delegated-information",
    "/identify",
    "/identify/success",
    "/direct/loan-application-form",
    "/direct/factoring-application-form",
    "/amount-estimator",
    "/eligibility-check",
    "/direct/real-estate-application-form",
    "/direct/leasing-application-form",
    "/application",
  ],
});

// Set global axios config
axios.defaults.baseURL = settings.backendBaseUrl;
axios.defaults.withCredentials = false;
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

// eslint-disable-next-line import/no-default-export
export default settings;
